// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3M2YU","title":"ClientReferral_title__3Q2zp","itemText":"ClientReferral_itemText__1XaMu"};